import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import chatReducer from './chatSlice';
import searchReducer from './searchSlice';
import userReducer from './userSlice';

// persist config: only chat and user slices
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['chat', 'user'],
};

const rootReducer = combineReducers({
  chat: chatReducer,
  search: searchReducer,
  user: userReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export default store;
